module.exports = __webpack_public_path__ + "img/IMG_9915.171b0607.jpg";